(function() {
	'use strict';
	angular.module('app.setup')
		.service('supplierLateDeliveryIssueService', supplierLateDeliveryIssueService);

	supplierLateDeliveryIssueService.$inject = ['$http', 'URLS'];
	function supplierLateDeliveryIssueService($http, URLS) {
		return {
			addLateDeliveryIssue: addLateDeliveryIssue,
			updateLateDeliveryIssue: updateLateDeliveryIssue,
			deleteLateDeliveryIssue: deleteLateDeliveryIssue
		};

		function addLateDeliveryIssue(lateDeliveryIssue, siteId) {
			var pageUrl = String.format(URLS.lateDeliveryIssue, siteId || globalConfig.factory.id);
			return $http.post(URLS.host + pageUrl, lateDeliveryIssue)
				.then(addLateDeliveryIssueSuccess, addLateDeliveryIssueFailure);

			function addLateDeliveryIssueSuccess(response) {
				return response;
			}

			function addLateDeliveryIssueFailure(response) {
				return response;
			}
		}

		function updateLateDeliveryIssue(lateDeliveryIssue, lastModified, siteId) {
			var pageUrl = String.format(URLS.lateDeliveryIssue, siteId || globalConfig.factory.id);
			return $http.put(URLS.host + pageUrl + '/' + lateDeliveryIssue.ndx, lateDeliveryIssue, {headers: {'If-Unmodified-Since': lastModified}})
				.then(updateLateDeliveryIssueSuccess, updateLateDeliveryIssueFailure);

			function updateLateDeliveryIssueSuccess(response) {
				return response;
			}

			function updateLateDeliveryIssueFailure(response) {
				return response;
			}
		}

		function deleteLateDeliveryIssue(lateDeliveryIssueNdx, siteId) {
			var pageUrl = String.format(URLS.lateDeliveryIssue, siteId || globalConfig.factory.id);
			return $http.delete(URLS.host + pageUrl + '/' + lateDeliveryIssueNdx)
				.then(deleteLateDeliveryIssueSuccess, handleError);

			function deleteLateDeliveryIssueSuccess(response) {
				return response;
			}
		}

		function handleError (error) {
			if (error.status === 403) {
				return '';
			} else if (error.status === 409) {
				return error.data.error;
			} else if (error.status === 412) {
				return error.data.error;
			}
			return 'Unknown server error';
		}
	}
})();
